import getterTypes from './getter-types'

export default {
  [getterTypes.GET_REQUIRED]: state => state.required,
  [getterTypes.GET_ANALYTICS]: state => state.analytics,
  [getterTypes.GET_MARKETING]: state => state.marketing,
  [getterTypes.GET_FACEBOOK_PIXEL]: state => state.facebookPixel,
  [getterTypes.GET_ACCEPT_ALL_URL]: state => state.acceptAllUrl,
  [getterTypes.GET_ACCEPT_SELECTED_URL]: state => state.acceptSelectedUrl,
}
